module.exports = __webpack_public_path__ + "img/sup_withdraw_crypto3.940134c8.jpg";